import React from 'react';
import { Link } from 'react-router-dom';
const CGV = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-pink-50 via-white to-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            <h1 className="text-5xl font-bold text-gray-900">
              Conditions Générales de <span className="text-pink-600">Vente</span>
            </h1>
            <video src="https://customer-assets.emergentagent.com/job_7bec0238-1e03-4c93-afc1-e7baf1238116/artifacts/nk3b9zei_logo-U2C.mp4" autoPlay loop muted playsInline className="h-24 w-auto flex-shrink-0 hidden sm:block rounded-lg" />
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Mise à jour : 06 mars 2026
          </p>
        </div>
      </section>

      {/* CGV Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8">
            
            {/* Préambule */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">0. Préambule</h2>
              <p className="text-gray-700 leading-relaxed">
                Les présentes Conditions Générales de Vente (CGV) pour prestation de service concernent la société URBA-2C, 
                Entreprise Individuelle enregistrée au Registre du Commerce et des Sociétés de ANGOULÊME sous le numéro SIREN 939574869, 
                dont le siège social est situé à 403 rue Madame Curie 16600 Ruelle, représentée par Monsieur LEDUC Christophe. 
                Le représentant de la société (ci-après « le Prestataire ») met à disposition ses prestations de services auprès de 
                client personne physique et personne morale (ci-après « le Client »).
              </p>
            </div>

            {/* Article 1 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Objet</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Les présentes conditions générales de vente (CGV) régissent les relations contractuelles entre URBA-2C, 
                Entreprise Individuelle enregistrée au Registre du Commerce et des Sociétés de ANGOULÊME sous le numéro SIREN 939 574 869, 
                dont le siège social est situé au 403 rue Madame Curie, 16600 RUELLE-SUR-TOUVRE, représentée par Leduc Christophe 
                (« le Prestataire »), et toute personne physique ou morale (« le Client ») souhaitant bénéficier des prestations 
                proposées par le Prestataire.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Les présentes Conditions Générales de Vente prévoient les conditions et les modalités d'exécution applicables 
                seulement aux prestations de service proposées par le Prestataire au Client, dont les caractéristiques sont les suivantes :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Création de dossiers administratifs relatifs aux autorisations d'urbanisme, de dessins techniques, de plans 
                d'architecture de projection en 2D et 3D, de prises de vues aériennes, de conseils en aménagement et de plans de 
                recollement (relevé de l'existant),</li>
                <li>Dépôt du dossier au service d'urbanisme du lieu de l'objet de la prestation ou au GNAU – Guichet Numérique 
                des Autorisations d'Urbanisme, à moins que les parties aient convenu que le Client prendra à sa charge le dépôt 
                du dossier après sa remise en main propre par le Prestataire.</li>
              </ul>
            </div>

            {/* Article 2 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Acceptation des CGV</h2>
              <p className="text-gray-700 leading-relaxed">
                Le Client déclare accepter les présentes Conditions Générales de Vente pour prestation de services sans réserve, 
                et cela, avant de passer commande par le retour du devis ou offre faite la société URBA-2C, es qualité de prestataire.
              </p>
            </div>

            {/* Article 3 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Prestations et Commandes</h2>
              <p className="text-gray-700 leading-relaxed">
                La commande est validée et effective dès la signature du devis et du règlement de l'acompte (à défaut du montant total) 
                par le Client. Les prestations ne concernent en aucun point la maîtrise d'œuvre du projet.
              </p>
            </div>

            {/* Article 4 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Prix et Modalités de Paiement</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Les prix sont exprimés en euros et sont Toutes Taxes Comprises (TTC), la micro-entreprise n'étant pas assujettie 
                à la TVA selon l'article 293 B du Code Général des Impôts.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Le moyen de paiement se fera par chèque, espèces ou virement. Aucun escompte pour un règlement anticipé ne sera 
                accordé par le Prestataire.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Les modalités de paiement seront précisées dans le devis et incluent un acompte de 30% ou non du montant total à 
                la commande. Le solde est exigible à la signature du devis. En cas d'annulation par le client, l'acompte versé reste 
                acquis à URBA-2C au titre de dédommagement, sauf accord contraire des parties.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Le Prestataire se réserve le droit de modifier le montant forfaitaire de l'acompte. Cette modification ne s'appliquera 
                pas aux contrats conclus avant celle-ci.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Le solde devra être entièrement réglé au jour de la réception du bien ou d'exécution de la prestation.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Les prix proposés pourront comprendre des rabais et ristourne accordés par le Prestataire en raison de ses résultats 
                ou de la prise en charge de prestation par le Client.
              </p>
              <p className="text-gray-700 leading-relaxed">
                A défaut de tout paiement du prix à son échéance, et après une mise en demeure restée sans effet dans un délai de 8 jours, 
                le Prestataire se réserve la faculté de suspendre la prestation de service en cours et/ou à venir.
              </p>
            </div>

            {/* Article 4.1 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4.1 Obligations</h2>
              <p className="text-gray-700 leading-relaxed">
                Le client s'engage à payer le prix de la prestation comme convenu au sein des présentes CGV. Il s'engage également 
                à collaborer afin de rendre possible la réalisation des prestations de services dans les meilleures conditions et notamment 
                de communiquer l'ensemble des documents et informations nécessaires à cette réalisation. Le prestataire s'engage à mettre 
                en œuvre toutes les mesures nécessaires afin de réaliser les prestations de services prévues au sein des présentes CGV.
              </p>
            </div>

            {/* Article 5 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Délais et Livraison</h2>
              <p className="text-gray-700 leading-relaxed">
                Les délais de livraison seront précisés au cas par cas sur le bon de commande et seront donnés à titre indicatif. 
                Ils ne constitueront donc pas un engagement ferme, sauf accord écrit. Tout retard ne pourra donner lieu à des dommages 
                et intérêts. En cas de circonstances imprévues ou de force majeure, le Prestataire peut modifier les délais sans pénalité. 
                En outre, la suspension du contrat par une cause de force majeure, celle-ci ne donnera droit à aucune indemnité de retard 
                pour le Client.
              </p>
            </div>

            {/* Article 6 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Responsabilités et Garanties</h2>
              <p className="text-gray-700 leading-relaxed">
                Le Prestataire s'engage à fournir une prestation de qualité, en conformité avec les normes en vigueur et les spécifications 
                demandées par le Client. Toutefois, sa responsabilité est limitée aux seuls dommages directs et prouvés, causés par une 
                faute dans l'exécution des prestations. Le Prestataire ne saurait être tenu responsable des modifications législatives ou 
                réglementaires postérieures à la livraison des documents.
              </p>
            </div>

            {/* Article 7 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Communication</h2>
              <p className="text-gray-700 leading-relaxed">
                Tous les plans, croquis, dessins et documents fournis dans le cadre des prestations restent la propriété intellectuelle 
                du prestataire sans délai. A ce titre, le prestataire se réserve le droit d'utiliser les images (photos, plans et documents 
                graphiques) de façon anonymisée à des fins de communication (site internet, publicité, etc.) Une fois le paiement effectué, 
                le Client acquiert un droit d'usage des documents le concernant.
              </p>
            </div>

            {/* Article 8 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Confidentialité, traitement des données à caractère personnel</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Le Prestataire s'engage à respecter la confidentialité des informations transmises par le Client dans le cadre de 
                l'exécution des prestations. Les informations personnelles du Client ne seront pas divulguées à des tiers sans autorisation 
                écrite du client.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Les informations personnelles obtenues par le prestataire seront conservées pendant un délai de 3 ans et seront ensuite détruites.
              </p>
            </div>

            {/* Article 9 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Résiliation - Retard de paiement</h2>
              <p className="text-gray-700 leading-relaxed">
                En cas de non-paiement ou d'inexécution d'une obligation du Client, le Prestataire peut résilier le contrat, après mise 
                en demeure par l'envoi d'un courrier en Recommandé avec Accusé de Réception restée sans réponse. La résiliation n'exonère 
                pas le Client du paiement des prestations déjà réalisées. En cas de retard de paiement, l'indemnité forfaitaire pour les 
                frais de recouvrement (40 €) est obligatoirement due dès lors que le paiement intervient après la date indiquée sur la facture.
              </p>
            </div>

            {/* Article 10 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Droit de rétractation</h2>
              <p className="text-gray-700 leading-relaxed">
                Le Client dispose d'un droit de rétractation dans les quatorze jours à compter de la conclusion du contrat. La rétractation 
                devra s'effectuer par l'envoi d'un courrier recommandé avec accusé de réception. Lors de la réception du courrier, le 
                Prestataire devra effectuer le remboursement dans un délai de quatorze jours, sous réserve de sa faculté de conserver 
                l'acompte qui sera payé par le Client lors de la signature du devis.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3 font-semibold">
                Toutefois, si le Client est un professionnel, le droit de rétractation n'est pas applicable.
              </p>
            </div>

            {/* Article 11 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Litiges et Droit Applicable</h2>
              <p className="text-gray-700 leading-relaxed">
                Les présentes Conditions générales de vente, ainsi que toute autre question non traitée par ces dernières, sont régies 
                par le droit français. En cas de litige, les parties s'engagent à chercher une solution amiable, soit entre elles, soit 
                en ayant recours à un médiateur. Dans le cas contraire, le litige sera porté devant le Tribunal compétent du lieu de 
                résidence du client.
              </p>
            </div>

            {/* Article 12 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Modification des CGV</h2>
              <p className="text-gray-700 leading-relaxed">
                Le Prestataire se réserve le droit de modifier les présentes CGV à tout moment. Les CGV applicables sont celles en 
                vigueur à la date de la commande.
              </p>
            </div>

            {/* Contact */}
            <div className="pt-8 border-t border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Contact</h3>
              <div className="space-y-2 text-gray-700">
                <p><strong>URBA-2C</strong></p>
                <p>403 rue Madame Curie, 16600 RUELLE-SUR-TOUVRE</p>
                <p>SIREN : 939 574 869</p>
                <p>Téléphone : <a href="tel:0761926962" className="text-pink-600 hover:text-pink-700">07.61.92.69.62</a></p>
                <p>Email : <a href="mailto:contact@urba2c.fr" className="text-pink-600 hover:text-pink-700">contact@urba2c.fr</a></p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default CGV;
